import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { Observable } from 'rxjs';
import { IReference } from '../../../../models/reference.model';
import { IReferenceSizeState } from '../../../../services/facades/master-data/reference-size-state.model';
import { ReferenceSizeFacade } from '../../../../services/facades/master-data/reference-size.facade';

@Component({
    selector: 'app-reference-size-dialog',
    templateUrl: './reference-size-dialog.component.html',
    styleUrls: [ './reference-size-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferenceSizeDialogComponent implements OnInit, AfterViewInit {
    public referenceSizeState$: Observable<IReferenceSizeState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IReference,
        private myMatDialogRef: MatDialogRef<ReferenceSizeDialogComponent>,
        private myReferenceSizeFacade: ReferenceSizeFacade,
    ) {
    }

    public ngOnInit(): void {
        this.referenceSizeState$ = this.myReferenceSizeFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((reference: IReference) => {
            this.validateDialogFields(reference);
        });
    }

    public async save(): Promise<void> {
        const data: IReference = this.formGroup.value as IReference;
        if (isNullOrUndefined(this.data.id)) {
            await this.myReferenceSizeFacade.addBezugsgroesse(data);
        } else {
            data.id = this.data.id;
            await this.myReferenceSizeFacade.editBezugsgroesse(data);
        }
        this.myMatDialogRef.close(true);
    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(reference: IReference): void {
        // Validations to disable saving/editing
        if (!reference.name || !reference.measureId) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
